let activeConfig = "Live";

let regionName = "us-central1";

// Notes to run on test
// You will need 2 terminal windows open
// Terminal 1: in the root folder run 'npm run dev'
// Terminal 2: in the functions folder run 'npm run dev'

// Config settings below
if (activeConfig == "Live") {
  // LIVE Credentials
  module.exports = {
    configName: "Live",
    creditUsage: {
      image: 1,
      ai: 0.5,
      aiAltText: 2,
      aiImage: 12,
    },
    defaultNumPostsToGenerate: 30,
    prod: {
      apiKey: "AIzaSyASlYe034IlR3L_79zcyENAFWQhK34S8hI",
      authDomain: "content-generator-8ab05.firebaseapp.com",
      projectId: "content-generator-8ab05",
      storageBucket: "content-generator-8ab05.firebasestorage.app",
      messagingSenderId: "413247457282",
      appId: "1:413247457282:web:83bc918d214fac9b76bf1b",
      measurementId: "G-PRW4YWRG15",
    },
    baseURL: "https://contentgenerator.io",
    apiBaseURL: `https://${regionName}-content-generator-8ab05.cloudfunctions.net`,
    regionName: regionName,
    initialPosts: [],
    pinterest: {
      appId: "1526320",
      redirectURL: "https://contentgenerator.io/profile",
    },
    x: {
      clientId: "RW9hYTRUVnJXV0w4Q1UycjZzVDg6MTpjaQ",
      redirectURL: "https://contentgenerator.io/profile",
    },
    facebook: {
      appId: "1495820134753157",
      redirectURL: "https://contentgenerator.io/profile",
    },
    instagram: {
      appId: "1155389933081187",
      redirectURL: "https://contentgenerator.io/profile",
    },
    linkedin: {
      clientId: "777jv32kmr659o",
      redirectURL: "https://contentgenerator.io/profile",
      scope:
        "openid profile email w_member_social w_organization_social r_organization_social",
    },
    pexels: {
      apiKey: "ZfXtBeK15kDdyO3I9muOTLZMDGJA5VeGmkNmszzH4HO9sP6V2bscPkBF",
    },
    etsy: {
      appName: "content-generator",
      keyString: "eozlng5lr316fkdg92amjfxr",
      clientId: "eozlng5lr316fkdg92amjfxr",
      redirectURL: "https://contentgenerator.io/products",
    },
    shopify: {
      apiKey: "#",
      redirectURL: "https://contentgenerator.io/products",
    },
    products: {
      productsPerPage: 50,
    },
    googleFonts: {
      apiKey: "AIzaSyAYpgh0Tn3F9ivMGyXXh2Y_os2Xm4TOnE0",
    },
    geoapify: {
      apiKey: "fc4dc3d59f6f493c9eb6d85c8a674f79",
    },
    recaptcha: {
      siteKey: "6LdA7okrAAAAAOBXVgA6V9_Wn5YADMInTjRJsvsK",
    },
  };
} else if (activeConfig == "Test") {
  // Test config
  module.exports = {
    configName: "Test",
    creditUsage: {
      image: 1,
      ai: 0.5,
      aiAltText: 2,
      aiImage: 12,
    },
    defaultNumPostsToGenerate: 30,
    prod: {
      apiKey: "AIzaSyASlYe034IlR3L_79zcyENAFWQhK34S8hI",
      authDomain: "content-generator-8ab05.firebaseapp.com",
      projectId: "content-generator-8ab05",
      storageBucket: "content-generator-8ab05.firebasestorage.app",
      messagingSenderId: "413247457282",
      appId: "1:413247457282:web:83bc918d214fac9b76bf1b",
      measurementId: "G-PRW4YWRG15",
    },
    baseURL: "http://localhost:2001",
    apiBaseURL: `http://localhost:5003/content-generator-8ab05/${regionName}`,
    regionName: regionName,
    testPlans: [
      {
        planId: "pro",
        amount: "29",
        planName: "Pro",
        paymentPeriod: "/month",
        features: [
          "1000 post credits per month",
          "Unlimited Social Media profiles",
          "Template builder",
          "AI writer",
          "AI image generator",
          "Import Canva template",
        ],
        planOrder: 1,
        planImage: "logoBronze192.webp",
        planDuration: "monthly",
        planStatus: "Active",
        postCreditLimit: 1000,
        stripePriceID: "price_1RwGRgLHEiqsKb6f5H0Jrw0f",
        freeTrialDays: 0,
        isUsingPriceParity: false,
        pricingParityOptions: {
          1: {
            amount: "29",
            stripePriceID: "price_1RwGRgLHEiqsKb6f5H0Jrw0f",
          },
        },
      },
      {
        planId: "proAnnual",
        amount: "299",
        planName: "Pro",
        paymentPeriod: "/year",
        features: [
          "1000 post credits per month",
          "Unlimited Social Media profiles",
          "Template builder",
          "AI writer",
          "AI image generator",
          "Import Canva template",
        ],
        planOrder: 1,
        planImage: "logoBronze192.webp",
        planDuration: "annual",
        planStatus: "Active",
        postCreditLimit: 1000,
        stripePriceID: "price_1RwGRxLHEiqsKb6fads2SrhX",
        freeTrialDays: 0,
        isUsingPriceParity: false,
        pricingParityOptions: {
          1: {
            amount: "299",
            stripePriceID: "price_1RwGRxLHEiqsKb6fads2SrhX",
          },
        },
      },
      {
        planId: "growth",
        amount: "49",
        planName: "Growth",
        paymentPeriod: "/month",
        features: [
          "3000 post credits per month",
          "Unlimited Social Media profiles",
          "Template builder",
          "AI writer",
          "AI image generator",
          "Import Canva template",
        ],
        planOrder: 2,
        planImage: "logoSilver192.webp",
        planDuration: "monthly",
        planStatus: "Active",
        postCreditLimit: 3000,
        stripePriceID: "price_1RwGSiLHEiqsKb6fKniHVnYe",
        freeTrialDays: 0,
        isUsingPriceParity: false,
        pricingParityOptions: {
          1: {
            amount: "49",
            stripePriceID: "price_1RwGSiLHEiqsKb6fKniHVnYe",
          },
        },
      },
      {
        planId: "growthAnnual",
        amount: "499",
        planName: "Growth",
        paymentPeriod: "/year",
        features: [
          "3000 post credits per month",
          "Unlimited Social Media profiles",
          "Template builder",
          "AI writer",
          "AI image generator",
          "Import Canva template",
        ],
        planOrder: 2,
        planImage: "logoSilver192.webp",
        planDuration: "annual",
        planStatus: "Active",
        postCreditLimit: 3000,
        stripePriceID: "price_1RwGSvLHEiqsKb6fuuAw83fM",
        freeTrialDays: 0,
        isUsingPriceParity: false,
        pricingParityOptions: {
          1: {
            amount: "499",
            stripePriceID: "price_1RwGSvLHEiqsKb6fuuAw83fM",
          },
        },
      },
      {
        planId: "enterprise",
        amount: "99",
        planName: "Enterprise",
        paymentPeriod: "/month",
        features: [
          "10000 post credits per month",
          "Unlimited Social Media profiles",
          "Template builder",
          "AI writer",
          "AI image generator",
          "Import Canva template",
        ],
        planOrder: 3,
        planImage: "logoGold192.webp",
        planDuration: "monthly",
        planStatus: "Active",
        postCreditLimit: 10000,
        stripePriceID: "price_1RwGTWLHEiqsKb6f32Xxf8Mt",
        freeTrialDays: 0,
        isUsingPriceParity: false,
        pricingParityOptions: {
          1: {
            amount: "99",
            stripePriceID: "price_1RwGTWLHEiqsKb6f32Xxf8Mt",
          },
        },
      },
      {
        planId: "enterpriseAnnual",
        amount: "999",
        planName: "Enterprise",
        paymentPeriod: "/year",
        features: [
          "10000 post credits per month",
          "Unlimited Social Media profiles",
          "Template builder",
          "AI writer",
          "AI image generator",
          "Import Canva template",
        ],
        planOrder: 3,
        planImage: "logoGold192.webp",
        planDuration: "annual",
        planStatus: "Active",
        postCreditLimit: 10000,
        stripePriceID: "price_1RwGTnLHEiqsKb6fMStKPGTq",
        freeTrialDays: 0,
        isUsingPriceParity: false,
        pricingParityOptions: {
          1: {
            amount: "999",
            stripePriceID: "price_1RwGTnLHEiqsKb6fMStKPGTq",
          },
        },
      },
    ],
    initialPosts: [],
    pinterest: {
      appId: "1526320",
      redirectURL: "http://localhost:2001/profile",
    },
    x: {
      clientId: "RW9hYTRUVnJXV0w4Q1UycjZzVDg6MTpjaQ",
      redirectURL: "http://localhost:2001/profile",
    },
    facebook: {
      appId: "1495820134753157",
      redirectURL: "https://localhost:2001/profile",
    },
    instagram: {
      appId: "1155389933081187",
      redirectURL: "https://localhost:2001/profile",
    },
    linkedin: {
      clientId: "777jv32kmr659o",
      redirectURL: "http://localhost:2001/profile",
      scope:
        "openid profile email w_member_social w_organization_social r_organization_social",
    },
    pexels: {
      apiKey: "ZfXtBeK15kDdyO3I9muOTLZMDGJA5VeGmkNmszzH4HO9sP6V2bscPkBF",
    },
    etsy: {
      appName: "content-generator",
      keyString: "eozlng5lr316fkdg92amjfxr",
      clientId: "eozlng5lr316fkdg92amjfxr",
      redirectURL: "http://localhost:2001/products",
    },
    shopify: {
      apiKey: "c60f015f3f14c4ff261c7f39672ea973",
      redirectURL: "http://localhost:2001/products",
    },
    products: {
      productsPerPage: 3,
    },
    googleFonts: {
      apiKey: "AIzaSyAYpgh0Tn3F9ivMGyXXh2Y_os2Xm4TOnE0",
    },
    geoapify: {
      apiKey: "fc4dc3d59f6f493c9eb6d85c8a674f79",
    },
    recaptcha: {
      siteKey: "6LdA7okrAAAAAOBXVgA6V9_Wn5YADMInTjRJsvsK",
    },
  };
}
